import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Toggle: shadcn/ui's Toggle on @radix-ui/react-toggle, a button that stays pressed (aria-pressed).
// Two looks from the kit:
//   button  a pressed control such as the composer's speak toggle (.wp-ibtn.is-active)
//   switch  a labelled on/off row with a track and thumb, as in the settings menu (.wp-switch)
// Enter and Space both flip it; the pressed state is the caller's to keep or Radix's to hold.
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva } from "class-variance-authority";
import { cn, focusRing, minTarget } from "./cn.js";
const toggleVariants = cva([
    "group cursor-pointer border-0 bg-transparent font-sans transition duration-fast ease-wp",
    "disabled:pointer-events-none disabled:opacity-45",
    minTarget,
    focusRing,
], {
    variants: {
        look: {
            button: [
                "inline-flex shrink-0 items-center justify-center gap-1.5 rounded-8 font-semibold leading-none",
                "text-wp-text-2 hover:bg-br-sky/9 hover:text-wp-text",
                "data-[state=on]:bg-wp-accent/13 data-[state=on]:text-wp-accent",
            ],
            switch: "flex w-full items-center gap-3 rounded-8 text-left text-wp-text",
        },
        compact: { false: "", true: "" },
    },
    compoundVariants: [
        { look: "button", compact: false, className: "h-8 min-w-8 px-2 text-13" },
        { look: "button", compact: true, className: "h-7 min-w-7 px-1.5 text-12" },
        { look: "switch", compact: false, className: "py-1.5" },
        { look: "switch", compact: true, className: "py-1" },
    ],
    defaultVariants: { look: "button", compact: false },
});
export function Toggle({ className, look, compact, hint, children, ...props }) {
    const isSwitch = look === "switch";
    return (_jsx(TogglePrimitive.Root, { "data-look": look ?? "button", "data-compact": compact ?? false, className: cn(toggleVariants({ look, compact }), className), ...props, children: isSwitch ? (_jsxs(_Fragment, { children: [_jsxs("span", { className: "flex min-w-0 flex-auto flex-col", children: [_jsx("span", { className: cn("font-semibold", compact ? "text-12" : "text-13"), children: children }), hint ? _jsx("span", { className: "text-12 leading-tight text-wp-text-3", children: hint }) : null] }), _jsx("span", { "aria-hidden": "true", className: cn("relative h-5 w-8.5 flex-none rounded-pill border border-wp-line-strong bg-br-sky/16", "transition-colors duration-med ease-wp", "group-data-[state=on]:border-transparent group-data-[state=on]:bg-wp-accent"), children: _jsx("span", { className: cn("absolute top-0.5 left-0.5 size-3.5 rounded-pill bg-wp-text-2", "transition duration-med ease-wp", "group-data-[state=on]:translate-x-3.5 group-data-[state=on]:bg-wp-accent-ink") }) })] })) : (children) }));
}
//# sourceMappingURL=toggle.js.map